// extracted by mini-css-extract-plugin
module.exports =  {"video-slide":"_93444fe79c--video-slide--DoHBl","preview":"_93444fe79c--preview--ZNVOo","preview--blur":"_93444fe79c--preview--blur--y35HY"};